export default __webpack_public_path__ + "static/media/trash.7bd78cae.svg";